import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants/constants';
import { getValueFromStorage } from '../helpers/helpers';

export const DailyOpsApi = createApi({
  reducerPath: 'dailyOps',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-type', 'application/json');
      headers.set('authorization', `Bearer ${getValueFromStorage('token')}`);
      return headers;
    },
  }),
  tagTypes: ['DailyOps'],
  endpoints: builder => ({
    getDailyOps: builder.query({
      query: ({ date, service } = {}) => ({
        url: `/api/appointment/getDailyOps`,
        method: 'GET',
        params: { date, service },
      }),
      providesTags: ['DailyOps'],
    }),
    updateLocker: builder.mutation({
      query: ({ id, locker_number }) => ({
        url: `/api/appointment/updateLocker/${id}`,
        method: 'PATCH',
        body: { locker_number },
      }),
      invalidatesTags: ['DailyOps'],
    }),
  }),
});

export const { useGetDailyOpsQuery, useUpdateLockerMutation } = DailyOpsApi;
